export default __webpack_public_path__ + "static/blockchain_game_back-6c99945be3d9ab32080ade9c94c44257.webp";